module.exports = __webpack_public_path__ + "54cf98f5/img/delete-icon.eb7de062.svg";